import clsx from 'clsx'

import { useDrawerContext } from './DrawerContext'

import styles from './DrawerDescription.module.scss'

type DrawerDescriptionProps = {
  visuallyHidden?: boolean
  children: React.ReactNode
}

export const DrawerDescription = ({
  visuallyHidden = false,
  children
}: DrawerDescriptionProps) => {
  const context = useDrawerContext()

  if (!context) {
    throw new Error(
      'DrawerDescription must be used inside a <Drawer> component.'
    )
  }

  return (
    <p
      id={`${context.id}-description`}
      className={clsx(styles.description, { 'visually-hidden': visuallyHidden })}
    >
      {children}
    </p>
  )
}

export default DrawerDescription

